import useScrollToTop from "../hooks/useScrollToTop";
import SubHeadingBanner from "../components/organisms/SubHeadingBanner";
import HeadingText from "../components/atoms/HeadingText";
import ParaText from "../components/atoms/ParaText";
import { BiSolidDirections } from "react-icons/bi";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import GetInTouchImg from "../assets/images/Contact us.jpeg";
import getConnect from "../assets/images/getconnect.avif";
import useTranslate from "../hooks/useTranslate";

function GetInTouch() {
  useScrollToTop();

  const iconMap = {
    biSolidDirections: BiSolidDirections,
    faPhoneAlt: FaPhoneAlt,
    faEnvelope: FaEnvelope,
  };

  const contactDetails = useTranslate("getInTouchPage.contactDetails");

  return (
    <>
      <SubHeadingBanner
        imageSrc={getConnect}
        head1="Home - Get In Touch"
        head2="Get In Touch"
      />
      <section className="bg-white py-12">
        <div className="max-w-6xl mx-auto my-8 px-4">
          <div className="flex justify-center mb-12">
            <img
              src={GetInTouchImg}
              alt="Contact Us"
              className="w-full max-w-[1500px] h-[526px] object-cover"
            />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 cursor-pointer">
            {contactDetails.map((card, index) => {
              const IconComponent = iconMap[card.icon];
              return (
                <div
                  key={index}
                  className={`bg-primary-100 p-4 text-center transition duration-300 ease-in-out hover:scale-105 shadow-md flex flex-col justify-center items-center`}
                  onClick={() =>
                    card?.action && (window.location.href = card.action)
                  }
                >
                  <div className="icon-container mb-2">
                    <IconComponent className="text-4xl text-primary" />
                  </div>
                  <HeadingText variant="h2" classes="!text-2xl">
                    {card.title}
                  </HeadingText>
                  <ParaText classes="whitespace-pre-line">{card.text}</ParaText>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}

export default GetInTouch;
